import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { driverSchema } from '../schemas/driver.schema';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Retrieves Drivers for a specific Driver Group
 * @param driverGroupId ID of Driver Group
 * @returns Message Object containing array of Drivers
 */
export function getDriverGroupsDrivers(this: unknown, driverGroupId: string) {
  const requestUrl = `${
    fleetEnvironment.resolve(this).driverGroupsDriversUrl
  }?includegroupId=${driverGroupId}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(driverSchema),
      })
    )
  );
}
